/* Lens guide filter.

   The prototype replaces the whole innerHTML of the list on every filter click,
   which throws away anything bound inside it. Here the rows are server-rendered
   once and only toggled, so there is nothing to rebind and no re-render cost.

   Filter state lives in aria-pressed rather than a class: it is simultaneously
   the accessibility state and the styling hook. docs/01 §4. */
(function () {
  'use strict';

  const H = window.Hystride;
  if (!H) return;

  H.register('lens-guide', {
    mount(root) {
      const buttons = Array.from(root.querySelectorAll('[data-guide-filter]'));
      const rows = Array.from(root.querySelectorAll('.gd-r[data-light]'));
      const empty = root.querySelector('[data-guide-empty]');
      if (!buttons.length) return null;

      const apply = (value) => {
        let shown = 0;
        rows.forEach((row) => {
          const match = value === 'all' || row.dataset.light === value;
          row.hidden = !match;
          if (match) shown += 1;
        });
        if (empty) empty.hidden = shown > 0;
      };

      const onClick = (e) => {
        const btn = e.target.closest('[data-guide-filter]');
        if (!btn) return;
        buttons.forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
        apply(btn.dataset.guideFilter);
      };

      // Delegated on the container, so the buttons themselves never need
      // individual listeners.
      const group = buttons[0].parentElement;
      group.addEventListener('click', onClick);

      const active = buttons.find((b) => b.getAttribute('aria-pressed') === 'true');
      apply(active ? active.dataset.guideFilter : 'all');

      return { group, onClick };
    },

    unmount(root, s) {
      s?.group.removeEventListener('click', s.onClick);
    },
  });
})();
